import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Toolbar,
  IconButton,
  Stack,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { purchaseArrtibuteApi, purchaseVanUpdateApi } from '../../Purchase/actions';
import { fAlertToast } from '../../../Utility/Utilitys';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export const VanUpdateModal = ({ open, onClose, data, fLoad }) => {
  const vMediaQuery = useMediaQuery('(max-width:650px)');

  const [sTruck, setTruck] = useState('');
  const [truckData, setTruckData] = useState([]);

  const fAttributes = async () => {
    const result = await purchaseArrtibuteApi({ OrderId: data?.Ord_ID });

    if (result.status === 200) {
      setTruckData(result?.data?.LocTruck);
      setTruck(data?.VanId || '');
    }
  };

  const handleSave = async () => {
    const obj = {
      VAN_TRNID: data?.Van_TransId,
      TRUCK_ID: sTruck
    };
    const result = await purchaseVanUpdateApi(obj);
    if (result.status === 200) {
      fAlertToast('SUCCESS', 'Truck updated successfully');
      fClose();
      fLoad();
    }
  };

  const fClose = () => {
    onClose();
    setTruck('');
  };

  useEffect(() => {
    if (open) {
      fAttributes();
      setTruck(data?.VanId);
    }
  }, [open]);

  return (
    <Dialog open={open} fullWidth maxWidth={vMediaQuery ? 'lg' : 'sm'}>
      <Toolbar sx={toolbar}>
        <DialogTitle sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0px !important' }}>
          Update Truck
        </DialogTitle>
        <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <DialogContent dividers sx={{ paddingX: vMediaQuery ? 1 : 4, paddingY: vMediaQuery ? 1 : 3 }}>
        <Stack
          mb={2}
          direction={vMediaQuery ? 'column' : 'row'}
          spacing={2}
          sx={{ justifyContent: 'space-between' }}>
          <Typography variant="body2" color={'primary'}>
            Van ID :{' '}
            <strong style={{ color: '#211111', fontWeight: 400 }}>{data?.Van_TransId}</strong>
          </Typography>
          <Typography variant="body2" color={'primary'}>
            Buyer : <strong style={{ color: '#211111', fontWeight: 400 }}>{data?.BuyerName}</strong>
          </Typography>
          <Typography variant="body2" color={'primary'}>
            Truck : <strong style={{ color: '#211111', fontWeight: 400 }}>{data?.TruckName}</strong>
          </Typography>
        </Stack>

        <Box py={2}>
          <FormControl fullWidth size="small">
            <InputLabel id="truck-label">Truck</InputLabel>
            <Select
              labelId="truck-label"
              id="truck-select"
              label="Truck"
              name="Truck"
              value={sTruck}
              onChange={(event) => setTruck(event.target.value)}>
              {truckData?.map((truck) => (
                <MenuItem key={truck.UId} value={truck.UId}>
                  {truck.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box textAlign={vMediaQuery ? 'center' : 'right'} pt={3}>
          <Button
            variant="contained"
            sx={{ textTransform: 'capitalize', width: vMediaQuery ? '40%' : '20%' }}
            onClick={handleSave}
            disabled={data?.Status === 'POST'}
            >
            Save
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
